/*
 *  Top Bar
 *    Scripts for the Top Bar object.
 *
 *
 *  Version:
 *    1.0.0 - 2019/04/17
 */

import {
  ON_CART_FINISHED,
  getCurrentCart,
  printMoney,
} from "@process-creative/slate-theme-tools";
import { CarouselSection } from "./../../sections/carousel/CarouselSection";
import { register } from "./../../sections/ShopifySection";
import * as ResponsiveSizes from "./../../settings/Responsive";
import { mainUpdateCSS } from "./../../tools/SetHeaderHeight";

export const CONTAINER_SELECTOR = "[data-topbar]";
export const CAROUSEL_SELECTOR = "[data-topbar-carousel]";
export const TOPBAR_REWARDS_DATA = "[data-topbar-rewards-data]";
export const TOPBAR_REWARDS_TEXT = "[data-topbar-rewards-text]";
export const TOPBAR_REWARDS_EXCLUDE = "[data-topbar-rewards-exclude]";

export class TopBar extends CarouselSection {
  constructor(container) {
    super(container);
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    this.slick = this.initCarousel(this.carouselContainer);
    this.slickInit = true;
    this.data = JSON.parse(container.find(TOPBAR_REWARDS_DATA).html());
    if (
      container.find(TOPBAR_REWARDS_EXCLUDE).length &&
      container.find(TOPBAR_REWARDS_EXCLUDE).html() != ""
    ) {
      this.excludedProducts = JSON.parse(
        container.find(TOPBAR_REWARDS_EXCLUDE).html().replace(/,\s*}/, "}")
      ); //todo: a better way to parse data
    }
    this.topbarRewardsText = container.find(TOPBAR_REWARDS_TEXT);
    $(document).on(ON_CART_FINISHED, () => this.onCartUpdated());
    mainUpdateCSS("[data-header-container]");
  }

  optionOverrides() {
    return {
      infinite: this.container.data("infinite") === true ? true : false,
      autoplay: this.container.data("autoplay") == true,
      autoplaySpeed: this.container.data("autoplay-speed") * 1000 || 5000,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: false,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall - 1,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            vertical: false,
            verticalSwiping: false,
          },
        },
      ],
    };
  }

  onCartUpdated() {
    let cart = getCurrentCart();
    this.data.some((block) => {
      if (!block.goal_amount) {
        this.topbarRewardsText.text(block.title);
        return true;
      }

      let totalExclude = 0;
      let lineItems = cart.items;

      if (this.excludedProducts && lineItems) {
        for (let index = 0; index < lineItems.length; index++) {
          if (this.excludedProducts[parseInt(lineItems[index].product_id)]) {
            totalExclude =
              totalExclude +
              this.excludedProducts[parseInt(lineItems[index].product_id)] *
                lineItems[index].quantity;
          }
        }
      }

      if (cart.original_total_price - totalExclude >= block.goal_amount)
        return false;

      let goalAmt =
        block.goal_amount - cart.original_total_price + totalExclude;
      let text = block.title.replace(/\$goal\$/gim, printMoney(goalAmt));
      if (cart.items.length != 0) text = block["s-initial"] || text;
      this.topbarRewardsText.text(text);
      return true;
    });
  }
}

register(CONTAINER_SELECTOR, TopBar);